<template>
    <div id="cars-info">
        <!--upload dialog-->
        <el-dialog
          :visible.sync="uploadVisible"
          size="tiny"
          :before-close="handleCloseUpload">
            <el-upload
                class="upload-demo"
                drag
                :action="uploadURl"
                :on-success="uploadSuccess"
                :on-error="uploadError"
                :headers="uploadHeaders"
                multiple
                :before-upload="beforeUpload">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">只能上传csv文件，且不超过5MB</div>
            </el-upload>
        </el-dialog>
        <!--add car dialog-->
        <el-dialog
          :title="carDialogTitle"
          :visible.sync="addVisible"
          size="small"
          :before-close="handleCloseAdd">
            <el-form :inline="true" :model="addDialogData" class="form-add" label-position="right" label-width="148px">
                <p>车辆信息</p>
                <el-form-item label="车牌号" required>
                    <el-input v-model="addDialogData.plate_number" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="车辆VIN码" required>
                    <el-input v-model="addDialogData.id" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="车辆型号">
                    <el-select v-model="addDialogData.vehicle_type" placeholder="请选择车辆型号">
                      <el-option label="比亚迪E6" value="比亚迪E6"></el-option>
                      <el-option label="北汽E5" value="北汽E5"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="ICCID号" >
                    <el-input v-model="addDialogData.iccid" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="驱动电机布置型式/位置" >
                    <el-input v-model="addDialogData.motor_deploy_info" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="最高车速" >
                    <el-input v-model="addDialogData.max_velocity" placeholder="">
                        <template slot="append">km/h</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="纯电续驶里程" >
                    <el-input v-model="addDialogData.electric_endurance_mileage" placeholder="">
                        <template slot="append">km</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="各档位传动比" >

                    <el-input v-model="addDialogData.gear_transmission_ratio.length" placeholder="" readonly="readonly" icon="caret-right"></el-input>
                </el-form-item>
                <el-form-item label="电机个数" >
                    <!--el-input v-model="addDialogData.num_of_motor" placeholder=""></el-input-->
                    <el-input-number v-model="addDialogData.num_of_motor" @change="handleChangeNumMotor" :min="1" :max="10"></el-input-number>
                </el-form-item>
                <el-form-item label="通用报警预置" >
                    <el-input v-model="addDialogData.common_alarm_value" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="电池个数" >
                    <!--el-input v-model="addDialogData.num_of_battery" placeholder=""></el-input-->
                    <el-input-number v-model="addDialogData.num_of_battery" @change="handleChangeNumBattery" :min="1" :max="10"></el-input-number>
                </el-form-item>
                <el-form-item label="发动机编号" >
                    <el-input v-model="addDialogData.engine_code" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="燃油类型" >
                    <el-input v-model="addDialogData.fuel_type" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="燃油标号" >
                    <el-input v-model="addDialogData.fuel_flag" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="发动机最大输出转矩" >
                    <el-input v-model="addDialogData.max_output_torque" placeholder="">
                        <template slot="append">N.米</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="发动机最大输出功率" >
                    <el-input v-model="addDialogData.max_output_power" placeholder="">
                        <template slot="append">W</template>
                    </el-input>
                </el-form-item>

                <div class="battery" v-for="(battery, index) in addDialogData.battery_data">
                    <p>电池信息{{index+1}}</p>
                    <el-form-item label="电池编码" >
                        <el-input v-model="battery.battery_sys_code" placeholder="" required></el-input>
                    </el-form-item>
                    <el-form-item label="电池类型" >
                        <!--el-input v-model="battery.battery_type" placeholder="" required></el-input-->
                        <el-select v-model="battery.battery_type" placeholder="请选择车辆型号">
                            <el-option label="磷酸铁锂电池" value="磷酸铁锂电池"></el-option>
                            <el-option label="锰酸锂电池" value="锰酸锂电池"></el-option>
                            <el-option label="三元材料电池" value="三元材料电池"></el-option>
                            <el-option label="聚合物锂离子电池" value="聚合物锂离子电池"></el-option>
                            <el-option label="超级电容" value="超级电容"></el-option>
                            <el-option label="钛酸锂电池" value="钛酸锂电池"></el-option>
                            <el-option label="其它电池" value="其它电池"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="电池冷却方式" >
                        <el-input v-model="battery.battery_cooling_type" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="电池总能量" >
                        <el-input v-model="battery.battery_energy_total" placeholder=""></el-input>
                    </el-form-item>
                </div>

                <div class="motor" v-for="(motor, index) in addDialogData.motor_data">
                    <p>电机信息{{index+1}}</p>
                    <el-form-item label="电机冷却方式" >
                        <el-input v-model="motor.motor_cooling_type" placeholder="" ></el-input>
                    </el-form-item>
                    <el-form-item label="额定电压" >
                        <el-input v-model="motor.rated_voltage" placeholder="" ></el-input>
                    </el-form-item>
                    <el-form-item label="最大工作电流" >
                        <el-input v-model="motor.max_work_current" placeholder="" ></el-input>
                    </el-form-item>
                    <el-form-item label="驱动机序号" >
                        <el-input v-model="motor.motor_code" placeholder="" r></el-input>
                    </el-form-item>
                    <el-form-item label="驱动电机型号" >
                        <el-select v-model="motor.motor_model" placeholder="请选择型号">
                            <el-option label="直流电动机" value="直流电动机"></el-option>
                            <el-option label="交流异步电动机" value="交流异步电动机"></el-option>
                            <el-option label="永磁式电动机" value="永磁式电动机"></el-option>
                            <el-option label="开关磁阻电机" value="开关磁阻电机"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="驱动电机最高转速" >
                        <el-input v-model="motor.motor_max_rev" placeholder="" >
                            <template slot="append">r/min</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="驱动电机峰值功率" >
                        <el-input v-model="motor.motor_peak_power" placeholder="" >
                            <template slot="append">w</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="驱动电机最大输出转矩" >
                        <el-input v-model="motor.motor_max_torque" placeholder="" >
                            <template slot="append">N.米</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="驱动电机峰值转矩" >
                        <el-input v-model="motor.motor_peak_torque" placeholder="" >
                            <template slot="append">N.米</template>
                        </el-input>
                    </el-form-item>
                </div>
                <el-form-item  >
                    <el-button type="primary" @click="submitAddForm('addDialogData')">保存</el-button>
                    <el-button @click="hideAddDialog">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <!--search form-->
        <el-form :inline="true" :model="formSearch" class="demo-form-inline">
            <el-form-item label="车牌号码" >
                <el-autocomplete
                    v-model="formSearch.plate_number"
                    :fetch-suggestions="queryPlate"
                    placeholder="请输入"
                ></el-autocomplete>
            </el-form-item>
            <el-form-item label="电池编码" >
                <el-autocomplete
                    v-model="formSearch.battery_code"
                    :fetch-suggestions="queryBattery"
                    placeholder="请输入"
                ></el-autocomplete>
            </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmitSearch">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onResetSearch">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onAddCar">添加</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onDownload">下载模板</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="uploadVisible = true">批量导入</el-button>
          </el-form-item>
        </el-form>


        <!--result table-->
        <el-table
          :data="tableData"
          style="width: 100%">
          <el-table-column
            min-width="80"
            prop="plate_number"
            label="车牌号码"
            align="center">
          </el-table-column>
          <el-table-column
            min-width="80"
            prop="vehicle_type"
            label="车辆型号"
            align="center">
          </el-table-column>
          <el-table-column
            min-width="80"
            prop="electric_endurance_mileage"
            label="纯电续驶里程"
            align="center">
            <template scope="scope">
                {{scope.row.electric_endurance_mileage + 'km'}}
            </template>
          </el-table-column>
          <el-table-column
            prop="max_velocity"
            label="最高车速"
            align="center">
            <template scope="scope">
                {{scope.row.max_velocity + 'km/h'}}
            </template>
          </el-table-column>
          <el-table-column
            prop="battery_data"
            label="电池编码"
            align="center">
            <template scope="scope">
                {{scope.row.battery_data[0].battery_sys_code}}
            </template>
          </el-table-column>
          <el-table-column
            prop="battery_data"
            label="电池类型"
            align="center">
            <template scope="scope">
                {{scope.row.battery_data[0].battery_type}}
            </template>
          </el-table-column>
          <el-table-column
            prop="battery_data"
            label="电池总能量"
            align="center">
            <template scope="scope">
                {{scope.row.battery_data[0].battery_energy_total + 'w'}}
            </template>
          </el-table-column>

           <el-table-column
              label="操作"
              width="120"
              align="center">
              <template scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="onEditCar(scope.row)"
                  >
                  编辑
                </el-button>
              </template>
            </el-table-column>
        </el-table>
        <div class="block" v-if="showPagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="formSearch.page"
              :page-size="formSearch.rows"
              layout=" prev, pager, next, sizes, jumper"
              :total="dataTotal">
            </el-pagination>
        </div>

    </div>
</template>

<script>
export default {
    name: 'cars-info',
    mounted () {
        // 上传文件的默认设置
        this.uploadURl = this.Api.vehicle;
        this.uploadHeaders = {
            'Authorization': localStorage.getItem('ACCESSTOKEN')
        };
        this.onResetSearch();
    },
    data () {
        return {
            formSearch: {
                plate_number: null,
                battery_code: null,
                page: 1,
                rows: 10,
                sort_type: null,
                sort_by: null
            },
            carDialogTitle: '新增车辆信息', // 编辑框的标题
            addDialogData: {
                id: '', // 车辆VIN码
                plate_number: '', // 车牌号
                vehicle_type: '', // 车辆型号
                iccid: '', // ICCID号
                motor_deploy_info: '', // 驱动电机布置型式/位置
                max_velocity: 0, // 最高车速
                electric_endurance_mileage: 0, // 纯电续驶里程
                gear_transmission_ratio: [], // 各档位传动比
                num_of_motor: 0, // 电机个数
                common_alarm_value: 0, // 通用报警预置
                num_of_battery: 0, // 电池个数
                engine_code: '', // 发动机编号
                fuel_type: '', // 燃油类型
                fuel_flag: '', // 燃油标号
                max_output_torque: 0, // 发动机最大输出转矩
                max_output_power: 0, // 发动机最大输出功率
                battery_data: [
                    {
                        battery_sys_code: '', // 电池编码
                        battery_type: '', // 电池类型
                        battery_cooling_type: '', // 电池冷却方式
                        battery_energy_total: 0  // 电池总能量
                    }
                ],
                motor_data: [
                    {
                        motor_cooling_type: '', // 电机冷却方式
                        rated_voltage: 0, // 额定电压
                        max_work_current: 0, // 最大工作电流
                        motor_code: '', // 驱动机序号
                        motor_model: '', // 驱动电机型号
                        motor_max_rev: 0, // 驱动电机最高转速
                        motor_peak_power: 0, // 驱动电机峰值功率
                        motor_max_torque: 0, // 驱动电机最大输出转矩
                        motor_peak_torque: 0 // 驱动电机峰值转矩
                    }
                ]
            },
            uploadVisible: false, // 是否显示上传对话框
            uploadURl: '',
            uploadHeaders: '',
            addVisible: false, // 是否显示编辑/添加对话框
            tableData: [], // table的数据
            dataTotal: 0 // table数据的总数
        };
    },
    methods: {
        onSubmitSearch () {
            /*
            * 提交搜索
            *
            */
            var self = this;
            var url = this.Api.vehicle;
            this.$ajax.get(url, {
                params: self.formSearch
            })
            .then(function (res) {
                if (res.status === 200) {
                    console.log(res);
                    self.tableData = res.data.data;
                    self.dataTotal = res.data.hits;
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        onResetSearch () {
            /*
            * 重置搜索
            *
            */
            this.formSearch = {
                plate_number: null,
                battery_code: null,
                page: 1,
                rows: 10,
                sort_type: null,
                sort_by: null
            };
            this.onSubmitSearch();
        },
        beforeUpload (file) {
            /*
            * 上传之前监测文件类型和文件大小
            *
            */
            console.log(file);
            const isCSV = file.type === 'text/csv';
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isCSV) {
                this.$message.error('上传文件类型只能是CSV格式!');
            }
            if (!isLt5M) {
                this.$message.error('上传文件大小不能超过 5MB!');
            }
            return isCSV && isLt5M;
        },
        uploadSuccess (response, file, fileList) {
            /*
            * 上传文件成功
            *
            */
            // console.log('response', response);
            this.onResetSearch();
            this.uploadVisible = false;
        },
        uploadError (err, file, fileList) {
            /*
            * 上传文件失败
            *
            */
            console.log('err', err);
            this.$message.error('文件上传失败,检查网络通畅后,请重新上传.');
        },
        handleCloseUpload (done) {
            // 点击关闭
            done();
        },
        handleCloseAdd (done) {
            // 点击关闭
            done();
        },
        querySearchAsync (field, queryString, cb) {
            /*
            * 关键字提示搜索
            *
            */
            var self = this;
            var url = this.Api.filter + '?field=' + field + '&value=' + queryString + '&rows=5';
            this.$ajax.get(url)
            .then(function (res) {
                if (res.status === 200) {
                    cb(self.getDataFormat(res.data));
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        getDataFormat (data) {
            /*
            * 关键字提示搜索,格式化以显示在页面上
            *
            */
            var result = [];
            for (var i = 0, len = data.length; i < len; i++) {
                result.push({value: data[i]});
            }
            return result;
        },
        queryBattery (queryString, cb) {
            /*
            * 电池编码关键字搜索
            *
            */
            this.querySearchAsync('battery_code', queryString, cb);
        },
        queryPlate (queryString, cb) {
            /*
            * 车牌编码关键字搜索
            *
            */
            this.querySearchAsync('production_vehicle_no', queryString, cb);
        },
        handleSizeChange (val) {
            /*
            * 选择每页多少条记录
            *
            */
            console.log(val);
            this.formSearch.rows = val;
            this.formSearch.page = 1;
            this.formSearch.page = 1;
            this.onSubmitSearch();
        },
        handleCurrentChange (val) {
            /*
            * 选择第几页
            *
            */
            this.formSearch.page = val;
            this.onSubmitSearch();
        },
        onDownload () {
            /*
            * 点击下载文件
            *
            */
            window.location = this.Api.templet;
        },
        onAddCar () {
            this.carDialogTitle = '新增车辆信息';
            this.showAddDialog();
            this.addDialogData = {
                id: '', // 车辆VIN码
                plate_number: '', // 车牌号
                vehicle_type: '', // 车辆型号
                iccid: '', // ICCID号
                motor_deploy_info: '', // 驱动电机布置型式/位置
                max_velocity: 0, // 最高车速
                electric_endurance_mileage: 0, // 纯电续驶里程
                gear_transmission_ratio: [], // 各档位传动比
                num_of_motor: 0, // 电机个数
                common_alarm_value: 0, // 通用报警预置
                num_of_battery: 0, // 电池个数
                engine_code: '', // 发动机编号
                fuel_type: '', // 燃油类型
                fuel_flag: '', // 燃油标号
                max_output_torque: 0, // 发动机最大输出转矩
                max_output_power: 0, // 发动机最大输出功率
                battery_data: [
                    {
                        battery_sys_code: '', // 电池编码
                        battery_type: '', // 电池类型
                        battery_cooling_type: '', // 电池冷却方式
                        battery_energy_total: 0  // 电池总能量
                    }
                ],
                motor_data: [
                    {
                        motor_cooling_type: '', // 电机冷却方式
                        rated_voltage: 0, // 额定电压
                        max_work_current: 0, // 最大工作电流
                        motor_code: '', // 驱动机序号
                        motor_model: '', // 驱动电机型号
                        motor_max_rev: 0, // 驱动电机最高转速
                        motor_peak_power: 0, // 驱动电机峰值功率
                        motor_max_torque: 0, // 驱动电机最大输出转矩
                        motor_peak_torque: 0 // 驱动电机峰值转矩
                    }
                ]
            };
        },
        onEditCar (val) {
            this.carDialogTitle = '编辑车辆信息';
            this.showAddDialog();
            this.addDialogData = val;
        },
        hideAddDialog () {
            this.addVisible = false;
        },
        showAddDialog () {
            this.addVisible = true;
        },
        handleChangeNumMotor (val) {
            /*
            * 点击下载文件
            *
            */
            console.log('机电的个数改变.', val);
        },
        handleChangeNumBattery (val) {
            /*
            * 点击下载文件
            *
            */
            console.log('机电的个数改变.', val);
        },
        submitAddForm () {
            var url = this.Api.vehicle;
            var self = this;
            if (this.carDialogTitle === '新增车辆信息') {
                /*
                * 新增车辆信息
                *
                */
                this.$ajax.post(url, this.addDialogData)
                .then(function (res) {
                    if (res.status === 200 || res.status === 204) {
                        self.hideAddDialog();
                        self.onResetSearch();
                    }
                })
                .catch(function (error) {
                    self.$message.error('请检查您的网络是否成功链接.');
                    console.log(error);
                });
            } else {
                /*
                * 编辑车辆信息
                *
                */
                this.$ajax.put(url + '/' + this.addDialogData.id, this.addDialogData)
                .then(function (res) {
                    if (res.status === 200 || res.status === 204) {
                        self.hideAddDialog();
                        self.onSubmitSearch();
                    }
                })
                .catch(function (error) {
                    self.$message.error('请检查您的网络是否成功链接.');
                    console.log(error);
                });
            }
        }
    },
    computed: {
        showPagination: function () {
            /*
            * 由总页数和每页数量来计算是否显示Pagination
            *
            */
            // return (this.dataTotal / this.formSearch.rows) > 1;
            return this.dataTotal > 10;
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#cars-info{
    background-color: #fff;
    margin: 15px 0;
    border: 1px solid #e0e3e7;
}
.el-button--primary{
    width: 80px;
}
.form-add{
    font-size: 14px;
    text-align: left;
}
.el-input-number,
.el-select,
.el-input{
    width: 220px;
    font-size: 13px;
}
.el-form-item{
    margin-bottom: 10px;
}
</style>
<style>
.form-add .el-form-item__label{
    font-size: 13px;
}
.form-add  .el-input__inner{
    height: 30px;
    font-size: 13px;
}
.form-add  .el-input-number__increase,
.form-add  .el-input-number__decrease{
    height: 29px;
    line-height: 29px;
    top: 4px;
}
</style>




// WEBPACK FOOTER //
// cars-info.vue?1aa7b5ae